var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5562 6.90918H10.6671H8.88932H8.88911V8.72736H8.88932V24.1816H8V25.9998H8.88932V26.0001H10.6671V25.9998H21.3343V26.0001H23.1121V25.9998H24V24.1816H23.1121V6.90918H23.1113H21.3343H20.4451V6H11.5562V6.90918ZM21.3343 24.1816V8.72736L10.6671 8.72736V24.1816H16.8891V19.6362H19.5558V24.1816H21.3343ZM12.4452 10.5454H15.1119V13.2727H12.4452V10.5454ZM15.1119 15.0908H12.4452V17.8181H15.1119V15.0908ZM12.4452 19.6362H15.1119V22.3635H12.4452V19.6362ZM19.5558 10.5454H16.8891V13.2727H19.5558V10.5454ZM16.8891 15.0908H19.5558V17.8181H16.8891V15.0908Z",
    fill: "#F99B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator);
export default __webpack_public_path__ + "static/media/operator.f70251391d800225c290d0418561c2f1.svg";
export { ForwardRef as ReactComponent };